import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router';
import { BoxIcon, KakaoMap, Text } from '#atoms';
import { PATH } from '#const/path';
import { Modal } from '#molecules';
import { Gym } from '#types/gyms';

import {
  ImageItem,
  ImageList,
  LabelBox,
  LecturePlacePageArea,
  LecturePlacePageWrap,
  Line,
  MainInfoArea,
  MapContainer,
  MoreBox,
  MoreBtn,
  PlaceInfoArea
} from './styles';
import { GymItems } from '#templates/CoachDetailContent/DetailInfo/LecturePlace/GymItems';
import { Link } from 'react-router-dom';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

interface Props {
  recommendGyms?: Gym[];
}

export const LectureLocation = ({ recommendGyms }: Props) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [targetIndex, setTargetIndex] = useState<number>(0);
  const [detailImage, setDetailImage] = useState<string | null>(null);
  const [isMore, setIsMore] = useState(false);
  const handleDetailClick = (image: string | null) => {
    setDetailImage(image);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setDetailImage(null);
  };

  const handleLocationButtonClick = (gymId: string) => {
    gymId && navigate(PATH.GYM_LOCATION, { state: { gymId } });
  };

  return (
    <LecturePlacePageWrap>
      <LabelBox>
        <Text style={{ fontSize: '18px' }}>수업 장소</Text>
        <Link to="/profile/gym">
          <BoxIcon type="edit-sharp" onlyIcon size={20} />
        </Link>
      </LabelBox>
      {recommendGyms && recommendGyms?.length ? (
        <>
          {
            <div className="flex justify-start items-center gap-8">
              {recommendGyms.map((gym, index) => (
                <div key={index}>
                  <input
                    type="radio"
                    className="peer hidden"
                    id={`gym-${gym.id}`}
                    name="test"
                    value={index}
                    onChange={() => setTargetIndex(index)}
                    checked={index === targetIndex}
                  />
                  <label
                    htmlFor={`gym-${gym.id}`}
                    className="rounded-22 py-6 px-16 border border-solid peer-checked:border-[#9170F2] peer-checked:text-[#9170F2] border-color-[#5C576B] text-[#5C576B] w-fit"
                  >
                    장소 {index + 1}
                  </label>
                </div>
              ))}
            </div>
          }
          <LecturePlacePageArea key={recommendGyms[targetIndex].id}>
            <MainInfoArea>
              <MapContainer
                onClick={() =>
                  handleLocationButtonClick(recommendGyms[targetIndex].id)
                }
              >
                <KakaoMap
                  latitude={Number(recommendGyms[targetIndex].lat)}
                  longitude={Number(recommendGyms[targetIndex].long)}
                  onMarkerClick={() =>
                    handleLocationButtonClick(recommendGyms[targetIndex].id)
                  }
                />
              </MapContainer>
              <div>
                <Text style={{ fontSize: '16px' }}>
                  {recommendGyms[targetIndex]?.name}
                </Text>
                <Text textStyle="c1" textColor="gray2">
                  {recommendGyms[targetIndex]?.address}
                </Text>
              </div>
              <Line />
              <MoreBox isMore={isMore}>
                {recommendGyms[0].images.length > 0 && (
                  <PlaceInfoArea>
                    <Text textStyle="t3">장소 사진</Text>
                    <ImageList>
                      {recommendGyms[0].images.map(img => (
                        <ImageItem key={img.id}>
                          <img
                            src={img.resizedLink}
                            onClick={() => handleDetailClick(img.uploadedLink)}
                          />
                        </ImageItem>
                      ))}
                    </ImageList>
                  </PlaceInfoArea>
                )}
                <PlaceInfoArea>
                  <Text textStyle="t3">편의 시설</Text>
                  <GymItems data={recommendGyms[0]} />
                </PlaceInfoArea>
                <PlaceInfoArea>
                  <Text textStyle="t3">전화번호</Text>
                  <Text textColor="gray2" style={{ whiteSpace: 'pre-wrap' }}>
                    {recommendGyms[targetIndex]?.phone}
                  </Text>
                </PlaceInfoArea>
                <PlaceInfoArea>
                  <Text textStyle="t3">공간 소개</Text>
                  <Text textColor="gray2" style={{ whiteSpace: 'pre-wrap' }}>
                    {recommendGyms[targetIndex]?.introduction}
                  </Text>
                </PlaceInfoArea>
              </MoreBox>
              <MoreBtn isMore={isMore} onClick={() => setIsMore(!isMore)}>
                {isMore ? '접기' : '더보기'}
              </MoreBtn>
            </MainInfoArea>
          </LecturePlacePageArea>

          {modalOpen && detailImage && (
            <Modal onClose={handleModalClose} transparent>
              <img className="modal-img" src={detailImage} />
            </Modal>
          )}
        </>
      ) : (
        <EmptyContent>수업 공간이 없습니다</EmptyContent>
      )}
    </LecturePlacePageWrap>
  );
};
